"use client";
import React, { useState } from "react";
import Link from "next/link";
import BarFooter from "@/src/components/BarFooter";
import dynamic from "next/dynamic";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "react-headless-accordion";

// const { Accordion, AccordionBody, AccordionHeader, AccordionItem } = dynamic(
//   () => import("react-headless-accordion"),
//   {
//     ssr: !!false,
//   }
// );

import CryptoTab_1 from "../../public/assets/banking/eternal-slots-binance-instant-withdrawals.webp";
import CryptoTab_2 from "../../public/assets/banking/eternal-slots-bitcoin-instant-withdrawals.webp";
import CryptoTab_3 from "../../public/assets/banking/eternal-slots-ethereum-instant-withdrawals.webp";
import CryptoTab_4 from "../../public/assets/banking/eternal-slots-litecoin-instant-withdrawals.webp";
import CryptoTab_5 from "../../public/assets/banking/eternal-slots-tether-instant-withdrawals.webp";
import CryptoTab_6 from "../../public/assets/banking/eternal-slots-visa-mastercardinstant-withdrawals.webp";
import CryptoTab_7 from "../../public/assets/banking/solana.png";
import CryptoTab_8 from "../../public/assets/banking/bitcoin-cash.png";
import CryptoTab_9 from "../../public/assets/banking/tron.png";
import CryptoTab_10 from "../../public/assets/banking/doge-coin.png";
import CryptoTab_11 from "../../public/assets/banking/bitcoin-lightning.png";
import CryptoTab_12 from "@/public/assets/banking/CashApp.png";
import CryptoTab_13 from "@/public/assets/banking/metamask.png";
import CryptoTab_14 from "@/public/assets/banking/PayPal.png";
import CryptoTab_15 from "@/public/assets/banking/toncoin.png";
import { OpenCashier } from "../../src/services/cashier";
import { useContext } from "react";
import { AppContext } from "../../src/context/AppContext";
// import Id1 from "../../public/assets/eternal-slots-proof-id-card-instant-withdrawals.webp";
// import Id2 from "../../public/assets/eternal-slots-proof-id2-card-instant-withdrawals.webp";
// import Id3 from "../../public/assets/eternal-slots-selfie-instant-withdrawals.webp";
// import IdBill from "../../public/assets/eternal-slots-proof-of-address-instant-withdrawals.webp";
import Image from "next/image";
import BarTop from "@/src/components/BarTop";

export default function PageBanking() {
  const [activeTab, setActiveTab] = useState("deposits");
  const { user, setIsClosed, isMobile, setLink, setOpenModal, setPageLoader } =
    useContext(AppContext);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const openCashier = () => {
    if (!user) setIsClosed(false);
    else {
      setPageLoader(true);
      OpenCashier("1")
        .then((response) => {
          setLink(response);
          isMobile && Tawk_API.hideWidget();
          setOpenModal(true);
        })
        .catch(() => {})
        .finally(() => setPageLoader(false));
    }
  };

  return (
    <div className="Pages">
      <BarTop />
      <div className="Wrapper">
        <h1>BANKING</h1>
        <div className="BoxPage">
          <>
            <div className="tabs">
              <button
                className={`tab-button ${
                  activeTab === "deposits" ? "active" : ""
                }`}
                onClick={() => handleTabClick("deposits")}
              >
                Deposit Options
              </button>
              <button
                className={`tab-button ${
                  activeTab === "bitcoin" ? "active" : ""
                }`}
                onClick={() => handleTabClick("bitcoin")}
              >
                Crypto Guide
              </button>
              <button
                className={`tab-button ${
                  activeTab === "payout" ? "active" : ""
                }`}
                onClick={() => handleTabClick("payout")}
              >
                Payout Options
              </button>
              {/* <button
                className={`tab-button ${
                  activeTab === "dverification" ? "active" : ""
                }`}
                onClick={() => handleTabClick("dverification")}
              >
                Documents Verification
              </button> */}
            </div>
            <div className="tab-content">
              {activeTab === "deposits" && (
                <div>
                  {/* <h2>Deposits Content</h2> */}

                  <p>
                    The GOAT Spins Casino ensures top-notch security for its
                    players, protecting them from potential online fraud by
                    utilizing SSL technology, which guarantees the highest level
                    of confidentiality for sensitive information. Among the
                    various payment options, cryptocurrency methods stand out
                    for their speed and affordability. <br />
                    <br /> We support a wide range of secure deposit methods,
                    including major cryptocurrencies, e-wallets, and trusted
                    payment providers, so you can fund your account quickly and
                    easily. <br />
                    <br /> Please note that while cryptocurrencies offer swift
                    transactions, processing fees imposed by your e-wallet may
                    apply. You can view these fees in the Cashier section during
                    transactions, so be sure to check before depositing.
                  </p>

                  <Link href="https://cdk.goatspins.com:3072/lobby?SkinId=1&show=login">
                    <div className="RowCryptosBK">
                      <Image
                        width={350}
                        height={50}
                        src={CryptoTab_1}
                        className="CryptoTabs"
                        alt="goat-spins-binance-instant-withdrawals"
                      />
                      <Image
                        width={350}
                        height={50}
                        src={CryptoTab_2}
                        className="CryptoTabs"
                        alt="goat-spins-bitcoin-instant-withdrawals"
                      />
                      <Image
                        width={350}
                        height={50}
                        src={CryptoTab_3}
                        className="CryptoTabs"
                        alt="goat-spins-ethereum-instant-withdrawals"
                      />
                      <Image
                        width={350}
                        height={50}
                        src={CryptoTab_4}
                        className="CryptoTabs"
                        alt="goat-spins-litecoin-instant-withdrawals"
                      />
                      <Image
                        width={350}
                        height={50}
                        src={CryptoTab_5}
                        className="CryptoTabs"
                        alt="goat-spins-tether-instant-withdrawals"
                      />
                      <Image
                        src={CryptoTab_7}
                        className="CryptoTabs"
                        alt="Mr. O Casino-solana-instant-withdrawals"
                      />
                      <Image
                        src={CryptoTab_8}
                        className="CryptoTabs"
                        alt="Mr. O Casino-bitcoin-cash-instant-withdrawals"
                      />
                      <Image
                        src={CryptoTab_9}
                        className="CryptoTabs"
                        alt="Mr. O Casino-tron-instant-withdrawals"
                      />
                      <Image
                        src={CryptoTab_10}
                        className="CryptoTabs"
                        alt="Mr. O Casino-doge-coin-instant-withdrawals"
                      />
                      <Image
                        src={CryptoTab_11}
                        className="CryptoTabs"
                        alt="Mr. O Casino-bitcoin-lightning-instant-withdrawals"
                      />
                      <div className="CryptoTabs imgBlocks">
                        <Image
                          width={350}
                          height={50}
                          src={CryptoTab_12}
                          alt="eternal-slots-visa-mastercardinstant-withdrawals"
                        />
                      </div>

                      <div className="CryptoTabs imgBlocks">
                        <Image
                          width={350}
                          height={50}
                          src={CryptoTab_13}
                          alt="eternal-slots-visa-mastercardinstant-withdrawals"
                        />
                      </div>
                      <div className="CryptoTabs imgBlocks">
                        <Image
                          width={350}
                          height={50}
                          src={CryptoTab_14}
                          alt="eternal-slots-visa-mastercardinstant-withdrawals"
                        />
                      </div>
                      <div className="CryptoTabs imgBlocks">
                        <Image
                          width={350}
                          height={50}
                          className="tonCoin"
                          src={CryptoTab_15}
                          alt="eternal-slots-visa-mastercardinstant-withdrawals"
                        />
                      </div>
                    </div>
                  </Link>

                  <p>
                    Additionally, the casino exclusively supports the ERC20
                    network for crypto transactions, ensuring seamless and
                    secure gaming experiences for cryptocurrency enthusiasts.
                    Using crypto at the casino not only offers financial
                    advantages but also enhances the overall player experience.
                  </p>
                </div>
              )}
              {activeTab === "payout" && (
                <div>
                  {/* <h2>Payout Content</h2> */}
                  <p>
                    At the casino, customers can withdraw their winnings
                    exclusively in{" "}
                    <span className="Color_Orange">Bitcoin (BTC)</span>,{" "}
                    <span className="Color_LbLUE">Litecoin (LTC)</span> and{" "}
                    <span className="Color_LbGreen">Tether (USDT)</span>. Before
                    requesting a payout, please ensure that you have provided
                    accurate and valid personal information to the company.
                  </p>
                  <Link href="https://cdk.goatspins.com:3072/lobby?SkinId=1&show=login">
                    <div className="RowCryptosBK">
                      <Image
                        width={350}
                        height={50}
                        src={CryptoTab_2}
                        className="CryptoTabs"
                        alt="goat-spins-bitcoin-instant-withdrawals"
                      />

                      <Image
                        width={350}
                        height={50}
                        src={CryptoTab_4}
                        className="CryptoTabs"
                        alt="goat-spins-litecoin-instant-withdrawals"
                      />

                      <Image
                        width={350}
                        height={50}
                        src={CryptoTab_5}
                        className="CryptoTabs"
                        alt="goat-spins-litecoin-instant-withdrawals"
                      />
                      <div className="CryptoTabs imgBlocks">
                        <Image
                          width={350}
                          height={50}
                          src={CryptoTab_12}
                          alt="eternal-slots-visa-mastercardinstant-withdrawals"
                        />
                      </div>
                    </div>
                  </Link>
                  <p>
                    The GOAT Spins Casino does not charge any payout fees and is
                    not responsible for any fees imposed by third-party
                    financial institutions involved in the receipt and
                    processing of customer payouts.
                  </p>
                  <p>
                    Please note that all payout options may be subject to
                    additional processing time as per international business
                    norms.
                  </p>
                </div>
              )}
              {activeTab === "bitcoin" && (
                <div>
                  {/* <h2>Bitcoin Content</h2> */}
                  <p>
                    Use Bitcoin at our casino easily. Get started, simply by
                    following these steps in our step-by-step guide
                  </p>

                  <>
                    <Accordion
                      transition={{
                        duration: "300ms",
                        timingFunction: "cubic-bezier(0, 0, 0.2, 1)",
                      }}
                    >
                      <AccordionItem>
                        {({ open }) => (
                          <>
                            <AccordionHeader className="AccordionHeader">
                              <div className={`accordion-title`}>
                                HOW TO DEPOSIT IN BTC?
                              </div>
                            </AccordionHeader>

                            <AccordionBody className="AccordionBody">
                              <div className="accordion-body-active">
                                <ul>
                                  <li>Open your Bitcoin wallet. </li>

                                  <li>
                                    Navigate to the Cashier section and select
                                    &quot;Bitcoin&quot; as your preferred
                                    deposit method.
                                  </li>

                                  <li>
                                    Enter the deposit amount in your chosen
                                    currency (USD, AUD, or EUR) and click
                                    &quot;Next.&quot;
                                  </li>

                                  <li>
                                    Copy the provided Bitcoin address and the
                                    corresponding amount, or scan the QR code
                                    directly from your mobile device using your
                                    Bitcoin wallet.
                                  </li>

                                  <li>
                                    After successfully sending the transaction
                                    from your Bitcoin wallet, click on &quot;Pay
                                    with Bitcoin.&quot; The credited amount will
                                    be automatically added to your casino
                                    account.
                                  </li>
                                </ul>
                              </div>
                            </AccordionBody>
                          </>
                        )}
                      </AccordionItem>
                    </Accordion>
                  </>

                  <p>
                    If you need help setting up your wallet, refer to our
                    comprehensive step-by-step guide on creating a Bitcoin
                    account or reach out to our friendly Customer Service team
                    via{" "}
                    <Link
                      href="/banking"
                      onClick={() => Tawk_API.maximize()}
                      className="Links"
                    >
                      live chat
                    </Link>{" "}
                    or email{" "}
                    <Link href="mailto:support@goatspins.com" className="Links">
                      support@goatspins.com
                    </Link>
                    . They are always ready to assist you!
                  </p>

                  <>
                    <Accordion>
                      <AccordionItem>
                        <AccordionHeader className="AccordionHeader P_05">
                          <div className={`accordion-title`}>
                            HOW TO CREATE YOUR BTC ACCOUNT?
                          </div>
                        </AccordionHeader>

                        <AccordionBody className="AccordionBody">
                          <div className="accordion-body">
                            <ul>
                              <li>
                                Choose the wallet type that suits your
                                preferences (web, desktop, or mobile).
                              </li>

                              <li>
                                Find the Bitcoin wallet you prefer and, if
                                needed, download and install it.
                              </li>

                              <li>
                                {" "}
                                Set up your account by creating a strong
                                password
                              </li>

                              <li>
                                Obtain your Bitcoin receiving address and ensure
                                you securely backup your wallet, either by using
                                a seed phrase or enabling two-factor
                                authentication (2FA).
                              </li>
                            </ul>
                          </div>
                        </AccordionBody>
                      </AccordionItem>
                    </Accordion>
                  </>
                </div>
              )}
              {activeTab === "dverification" && (
                <div>
                  {/* <h2>Payout Content</h2> */}
                  <p>
                    To ensure secure gaming and smooth payout validation,
                    customers are required to submit various documents outlined
                    below. Goat spins assures the complete privacy of all
                    submitted documents and sensitive data. To expedite the
                    processing of your payout, please adhere to the provided
                    example.
                  </p>

                  <p>Important points to note:</p>

                  <ul>
                    <li>All transactions are irreversible.</li>
                    <li>
                      Deposit and/or cashout methods may vary based on your
                      current location; please verify their availability in the
                      Cashier.
                    </li>
                    <li>
                      All transactions are conducted at the exchange rate linked
                      to the currency of your bank account or chosen payment
                      service.{" "}
                    </li>
                    <li>
                      goat spins does not impose additional fees on your
                      transactions and cannot be held responsible for any fees
                      charged by your bank or other payment service provider.
                    </li>
                  </ul>

                  {/* GREEN BOX */}
                  <div className="ContRowBoxesDet">
                    <div className="RowBoxesDet">
                      <h2 className="TitleCard">Proof of ID</h2>
                      <p className="Parraf">
                        Proof of identity (driver’s license, ID, passport).
                        Please make sure to capture both sides of the
                        identification.
                      </p>
                      <div className="ContCards">
                        <Image
                          width={350}
                          height={50}
                          src={Id1}
                          alt="goat-spins-proof-id-card-instant-withdrawals"
                          className="CardsId"
                        />
                        <Image
                          width={350}
                          height={50}
                          src={Id2}
                          alt="goat-spins-proof-id2-card-instant-withdrawals"
                          className="CardsId"
                        />
                      </div>
                    </div>

                    {/* GREEN BOX */}
                    <div className="RowBoxesDet" style={{ paddingBottom: 0 }}>
                      <h2 className="TitleCard">A selfie holding your card</h2>
                      <p className="Parraf">
                        A selfie holding your ID, driver&apos;s licence or
                        passport.
                      </p>
                      <div className="ContCards">
                        <Image
                          width={350}
                          height={50}
                          src={Id3}
                          alt="goat-spins-selfie-instant-withdrawals"
                          className="CardsIdCredit"
                        />
                      </div>
                    </div>

                    {/* GREEN BOX */}
                    <div className="RowBoxesDet">
                      <h2 className="TitleCard">Proof of Address</h2>
                      <p className="Parraf">
                        Proof of address (utility, medical or delivery bill or
                        any official document with your full name, address and
                        date. Please note the document must have been issued
                        within the recent 2 months).
                      </p>
                      <div className="ContCards">
                        <Image
                          width={350}
                          height={50}
                          src={IdBill}
                          alt="goat-spins-proof-of-address-instant-withdrawals"
                          className="CardsId"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>

          {/* <>
            <Accordion>
              <AccordionItem>
                <AccordionHeader className="AccordionHeader P_05">
                  <div className={`accordion-title`}>
                    TITLE TAB ACCORDION
                  </div>
                </AccordionHeader>

                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam sunt doloremque omnis maxime porro quaerat voluptas accusamus und
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

            </Accordion>
          </> */}
        </div>
      </div>
      {/* <BarFooter /> */}
    </div>
  );
}
